var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "confirmModal",
      attrs: {
        showCloseBtn: false,
        modalId: _vm.modalId,
        modalType: _vm.modalType,
      },
    },
    [
      _c("div", { attrs: { slot: "modal-header" }, slot: "modal-header" }, [
        _c("p", {
          class: [
            "action-confirm-title",
            _vm.requiredFlag ? "required-flag" : "",
          ],
          domProps: { innerHTML: _vm._s(_vm.confirmTitleText) },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
        _vm.showCancelBtn
          ? _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.cancel()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.cancelBtnText))]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--orange",
            attrs: { disabled: _vm.disabledConfirmBtn, type: "button" },
            on: {
              click: function ($event) {
                return _vm.confirm()
              },
            },
          },
          [_vm._v(_vm._s(_vm.confirmBtnText))]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }